export const GET_INCIDENTS_FOR_FORM = 'GET_INCIDENTS_FOR_FORM';
export const FLAG_GETTING_INCIDENTS_FOR_FORM = 'FLAG_GETTING_INCIDENTS_FOR_FORM';
export const CLEAR_INCIDENTS_FOR_FORM = 'CLEAR_INCIDENTS_FOR_FORM';